import { Component, Input } from '@angular/core';
import { ColDef } from 'ag-grid-community/dist/lib/entities/colDef';
import { Observable, of } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

import {
  AggFunc,
  BaseComponent,
  GridService,
  Product,
  ProductsForCreatePurchaseOrder,
  ProductStockAllocations,
  SalesOrderStockAllocationService,
  StockItem,
  StockItemService,
  SummaryItem,
} from 'tms-lib';

@Component({
  selector: 'app-stock-items-by-product',
  templateUrl: './stock-items-by-product.component.html',
  styleUrl: './stock-items-by-product.component.scss',
})
export class StockItemsByProductComponent extends BaseComponent {
  @Input() model: StockItem[];
  @Input() summaryItem: ProductsForCreatePurchaseOrder;
  @Input() showDelete = false;
  @Input() productId: string;

  constructor(
    private gridService: GridService,
    private salesOrderStockAllocationService: SalesOrderStockAllocationService,
    private stockItemService: StockItemService,
  ) {
    super();
  }

  summaryItems(model: ProductStockAllocations): SummaryItem[] {
    return [
      { label: $localize`Product`, value: model.productKey },
      { label: $localize`Description`, value: model.productDescription },
      { label: $localize`Product Type`, value: model.productType },
    ];
  }

  readonly columnDefs: ColDef[] = [
    this.gridService.text('stockNo', $localize`Stock Number`),
    this.gridService.text('warehouseKey', $localize`Warehouse`),
    this.gridService.text('locationKey', $localize`Location`),
    this.gridService.numberFormat('balance', $localize`Balance`, { aggFunc: AggFunc.sum }),
    this.gridService.numberFormat('totalAllocated', $localize`Allocated`, { aggFunc: AggFunc.sum }),
    this.gridService.numberFormat('freeStock', $localize`Free Stock`, { aggFunc: AggFunc.sum }),
  ];

  get rowData$(): Observable<StockItem[]> {
    return of(this.model ?? []);
  }

  getModel() {
    this.stockItemService
      .stockItemsByProduct(this.productId)
      .pipe(takeUntil(this.destroy$))
      .subscribe((model: StockItem[]) => (this.model = model));
  }
}
